import { lazy } from "react";

export const SoulMatrixPage = lazy(() =>
  import("./page").then((module) => ({
    default: module.Page,
  }))
);
